import {
  useEsitoHeaders,
  useInfoAggiuntivaBilanciata,
  useInfoAggiuntivaData,
  useInfoAggiuntivaMeta,
} from 'features/sport/hooks';

import { EsitiUnderThreeWithInfoAggEstesaItemProps } from '.';
import { ScommesseEsitoTipoBox } from 'components/scommesseEsitoTipoBox';
import { ScommesseListing } from '../wrappers/scommesseListing';
import { useMemo } from 'react';
import { useTranslation } from 'hooks/useLingUI';
import useWindowSize from 'hooks/useWindowSize';

export const EsitiUnderThreeWithInfoAggEstesaItem = ({
  showHeader,
  gtagAction,
  scommessaKey,
  infoAggiuntivaKey,
}: EsitiUnderThreeWithInfoAggEstesaItemProps) => {
  const { t } = useTranslation();

  const { valore, valoreTrKey } = useInfoAggiuntivaData(infoAggiuntivaKey);
  const sortedEsitoKeyList = useEsitoHeaders(scommessaKey, infoAggiuntivaKey, undefined, false);
  const { bilanciataKey } = useInfoAggiuntivaBilanciata(scommessaKey);

  const isBalanced = useMemo(() => bilanciataKey === infoAggiuntivaKey, [bilanciataKey, infoAggiuntivaKey]);
  const infoAggMeta = useInfoAggiuntivaMeta(scommessaKey);
  const { headers, headersTrKey } = infoAggMeta ?? {};
  const headerInfoAgg = headers ? headers[0] : '';
  const headerTrKeyInfoAgg = headersTrKey ? headersTrKey[0] : '';
  const { isMobile } = useWindowSize();

  return (
    <ScommesseListing.Row
      key={infoAggiuntivaKey}
      infoAggiuntivaKey={infoAggiuntivaKey}
      header={headerInfoAgg}
      isBalanced={isBalanced}
      headerTrKey={headerTrKeyInfoAgg}
      infoAggiuntiva={t(valoreTrKey, valore)}
    >
      {sortedEsitoKeyList?.map(({ key }) => (
        <ScommesseEsitoTipoBox
          key={key}
          keyEsito={key}
          showHeader={isMobile && showHeader}
          showHeaderOutside={!isMobile && showHeader}
          scommessaKey={scommessaKey}
          infoAggiuntivaKey={infoAggiuntivaKey!}
          gtagAction={gtagAction}
        />
      ))}
    </ScommesseListing.Row>
  );
};
